import helperStyles from "@src/components/helpers.module.scss";
import React from "react";

export const MobileIcon: React.FC = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M8.66667 12.6248C9.03486 12.6248 9.33333 12.3264 9.33333 11.9582C9.33333 11.59 9.03486 11.2915 8.66667 11.2915C8.29848 11.2915 8 11.59 8 11.9582C8 12.3264 8.29848 12.6248 8.66667 12.6248Z"
					fill="currentColor"
				/>
				<path
					d="M11.8188 14.6247H5.51618C5.09792 14.5997 4.70643 14.4106 4.42689 14.0985C4.14735 13.7864 4.00238 13.3765 4.02351 12.958V3.04203C4.00238 2.62356 4.14735 2.21368 4.42689 1.90155C4.70643 1.58943 5.09792 1.40032 5.51618 1.37537H11.8188C12.2371 1.40032 12.6286 1.58943 12.9081 1.90155C13.1877 2.21368 13.3326 2.62356 13.3115 3.04203V12.958C13.3326 13.3765 13.1877 13.7864 12.9081 14.0985C12.6286 14.4106 12.2371 14.5997 11.8188 14.6247ZM5.51618 2.04203C5.27503 2.0675 5.05348 2.18648 4.89906 2.37343C4.74464 2.56039 4.66964 2.80042 4.69018 3.04203V12.958C4.66964 13.1996 4.74464 13.4397 4.89906 13.6266C5.05348 13.8136 5.27503 13.9326 5.51618 13.958H11.8188C12.06 13.9326 12.2815 13.8136 12.436 13.6266C12.5904 13.4397 12.6654 13.1996 12.6448 12.958V3.04203C12.6654 2.80042 12.5904 2.56039 12.436 2.37343C12.2815 2.18648 12.06 2.0675 11.8188 2.04203H5.51618Z"
					fill="currentColor"
				/>
			</svg>
		</div>
	);
};
